import React from 'react';
import { ContextReducerAction, ReducerPayload } from './reducer';

export interface APIContext {
  state?: ReducerPayload;
  dispatch?: React.Dispatch<ContextReducerAction>;
}
// Creating the context object and passing the default values.
export const APIWebstoreContext = React.createContext<APIContext>({});
